import Select from "react-select";
import { tOption as SelectOption } from "../../Models/Select";

import {
  ErrorContainer,
  ErrorMessage,
  selectStyles,
  Label,
  SelectContainer,
  Asterisk,
} from "./ReactSelect.styled";

import { Container, Row, Column } from "../Grid";
import Icon from "../Icon";

// eslint-disable-next-line
const ReactSelect = (props: any) => {
  const {
    ref,
    options,
    nameSelect,
    placeholder,
    textLabel,
    onBlur,
    onChange,
    value,
    errors,
  } = props;

  return (
    <Container>
      <Row>
        <Column span={12} as={SelectContainer}>
          <Label>
            <Asterisk>*</Asterisk>
            {textLabel}
          </Label>
          <Select
            ref={ref}
            options={options}
            name={nameSelect}
            styles={selectStyles}
            placeholder={placeholder}
            onBlur={onBlur}
            onChange={(newValue) => onChange(newValue as SelectOption)}
            value={value ? value : ""}
          />
          {errors[nameSelect] && (
            <ErrorContainer>
              <Icon
                icon="alertTriangle"
                color="Amaranth_Red"
                size="small"
                fillIcon={false}
              />
              <ErrorMessage>{errors[nameSelect].message}</ErrorMessage>
            </ErrorContainer>
          )}
        </Column>
      </Row>
    </Container>
  );
};

export default ReactSelect;
